export default __webpack_public_path__ + "static/media/technology.5d74d87c.jpg";